import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { base_url } from '../Api/Api';
import Skltn from './Skltn';
import CardGlobal from '../MainPage/CardGlobal';

const Recomandation = (props) => {

    const [state, setState] = useState({
        data: [],
        loader: true,
        statusData: false
    })

    useEffect(() => {

        window.scrollTo(0, 0)

        base_url.get(`recommend_items`)
            .then(response => {
                setState({
                    ...state,
                    data: response.data.recommendItems,
                    statusData: response.data.recommendItems.length == 0,
                    loader: false
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, [])

    return (
        <div className="innerWebinar recomand">
            <div className="contain">
                <div className="inner-body">
                    <div className="backward">
                        <h6>کورس های پیشنهادی</h6>
                        <span onClick={() => props.history.goBack()}>بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i></span>
                    </div>
                    <div className="body">
                        {state.data.length == 0 ?
                            state.statusData ?
                                <span className="no-content">موردی برای نمایش وجود ندارد.</span>
                                :
                                <Skltn />
                            :
                            state.data.map(info =>
                                <CardGlobal
                                    key={info.id}
                                    id={info.id}
                                    image={info.image}
                                    title={info.title}
                                    tags={[]}
                                    date={info.created_at}
                                    comment={info.comment_count}
                                    link={`/education/category/${info.id}`} />
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Recomandation;